import React from "react"
import styled from "@emotion/styled"
import ReactHtmlParser from "react-html-parser"
import { deviceMinW } from "../../../styles/mediaQueries"
import { fontSize, lineHeight } from "../../../styles/fonts/fontStyle"
import { colors } from "../../../styles/colors"
import { spacer } from "../../../styles/sizes"

const Blockquote = ({ bquote }) => {
    return <Quote>{ReactHtmlParser(bquote)}</Quote>
}
export default Blockquote

const Quote = styled.blockquote`
    font-size: ${fontSize.canon};
    line-height: ${lineHeight.canon};
    margin: 4rem 0 8rem;
    padding-bottom: ${spacer.l};
    border-bottom: 1px solid ${colors.electricViolet};

    @media ${deviceMinW.tablet} {
        padding-bottom: ${spacer.xl};
        font-size: ${fontSize.canon};
        line-height: 5.3rem;
        max-width: 80rem;
    }
`
